import { HttpClient } from '@angular/common/http';
import { InjectionToken, NgModule, Optional, SkipSelf } from '@angular/core';
import { ConfigLoader, ConfigModule } from '@ngx-config/core';
import { ClientProps, EnvironmentInformation } from './config.types';
import { MngConfigHttpLoader } from './mng-config-http-loader';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

export const ENVINFO_API_URL = new InjectionToken<string>('envInfoApiUrl');

// Hier definierte Properties werden als Fallback verwendet wenn der Endpoint nicht erreichbar ist

const FALLBACK_CONFIG: EnvironmentInformation<ClientProps> = {
  service: {
    environment: 'UNKNOWN',
    version: 'UNKNOWN',
    defaultAppUrl: null
  },
  clientProps: {
    analyticsIdSales: null,
    analyticsIdKpor: null,
    cobrowsingWidgetKey: null,
    salesCustomerRegistrationAllowed: false,
    salesIncompleteAngebotAllowed: false,
    salesPersonLimit: 15,
    gvRueckdatierungStichtag: 22,
    gvStichdatumMaxOffset: 8,
    gvStichdatumVisible: false,
    gvStichdatumBlicktarifVisible: false,
    salesPrintIncompleteAntrag: false,
    esignQesEnabled: false,
    gvExtraWeeksFormaleAenderungImLeistungsfall: 4,
    gvValidityException: null,
    misAjaxServer: '',
    misAjaxNatsessionId: '',
    merkurWebsiteBaseUrl: null,
    merlinUrl: null,
    eWorkplaceHost: null,
    dmsServletPort: null,
    abkommenExtVermittlerNotwendig: null,
    salesGvVertragLadenMinStichtag: '2024-04-01',
    kvTarifwerkErstellungsDatum: '2000-07-17',
    svSchadensMeldungEnabled: false,
    deineGeburtOnlineEnabled: false,
    gesundheitsfragen2026Enabled: false,
    vertriebspartnerEditModeEnabled: false,
    vertriebspartnerAutoPortalUserCreationEnabled: false,
    portalLizenzEditEnabled: false,
    vertriebspartnerExportSyncThreshold: 500,
    vertriebspartnerExportMaxPollMinutes: 60,
    partnerZusammenlegungOhneLvCheckEnabled: false,
    leistungseinreichungMaxFileCount: 10,
    leistungseinreichungMaxSingleFileSizeBytes: 30 * 1024 * 1024,
    leistungseinreichungMaxTotalUploadSizeBytes: 30 * 1024 * 1024,
    leistungseinreichungMaxPdfPages: 10
  }
};

export function configFactory(http: HttpClient, apiUrl: string): ConfigLoader {
  return new MngConfigHttpLoader(http, apiUrl, FALLBACK_CONFIG);
}

@NgModule({
  imports: [
    ConfigModule.forRoot({ provide: ConfigLoader, useFactory: configFactory, deps: [HttpClient, ENVINFO_API_URL] })
  ],
  providers: [
    {
      provide: ENVINFO_API_URL,
      useValue: '../envinfo/api/public/envInfo'
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { backdropClass: 'dialog-backdrop' }
    }
  ]
})
export class MngConfigModule {
  constructor(@Optional() @SkipSelf() parentModule: MngConfigModule) {
    if (parentModule) {
      throw new Error('MngConfigModule is already loaded. Import it in the AppModule only');
    }
  }
}
